"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ChartLineIcon =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ChartLineIcon, _PureComponent);

  function ChartLineIcon() {
    _classCallCheck(this, ChartLineIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(ChartLineIcon).apply(this, arguments));
  }

  _createClass(ChartLineIcon, [{
    key: "render",
    value: function render() {
      var color = this.props.color;
      return _react2.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36.026 27.02",
        style: {
          fill: color,
          enableBackground: 'new 0 0 63 63'
        }
      }, _react2.default.createElement("path", {
        className: "a",
        d: "M34.9,86.516H4.5V65.126A1.126,1.126,0,0,0,3.377,64H1.126A1.126,1.126,0,0,0,0,65.126V88.768A2.252,2.252,0,0,0,2.252,91.02H34.9a1.126,1.126,0,0,0,1.126-1.126V87.642A1.126,1.126,0,0,0,34.9,86.516ZM32.649,66.252H24.342a1.689,1.689,0,0,0-1.194,2.883l2.28,2.28-5.163,5.163L15.1,71.415a2.251,2.251,0,0,0-3.184,0L7.085,76.248a1.126,1.126,0,0,0,0,1.592l1.592,1.592a1.126,1.126,0,0,0,1.592,0L13.51,76.19l5.163,5.163a2.251,2.251,0,0,0,3.184,0L28.611,74.6l2.28,2.28a1.689,1.689,0,0,0,2.883-1.194V67.377A1.124,1.124,0,0,0,32.649,66.252Z",
        transform: "translate(0 -64)"
      }));
    }
  }]);

  return ChartLineIcon;
}(_react.PureComponent);

exports.default = ChartLineIcon;